// extracted by mini-css-extract-plugin
export var container = "_5e-0";
export var fallback = "_5e-5";
export var fallbackIcon = "_5e-6";
export var hidden = "_5e-2";
export var image = "_5e-3";
export var loaded = "_5e-4";
export var placeholder = "_5e-1";